import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Packshot from "@/components/Packshot";

const cardSpring = { type: "spring", stiffness: 260, damping: 18 };

export default function ProductCard({ product, index, onOpen }) {
  const handleOpen = () => onOpen(product);
  const handleKey = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleOpen();
    }
  };

  return (
    <motion.article
      className="catalog-card"
      data-testid={`catalog-product-${index + 1}`}
      whileHover={{ y: -8 }}
      transition={cardSpring}
      onClick={handleOpen}
      role="button"
      tabIndex={0}
      onKeyDown={handleKey}
    >
      <div className="catalog-packshot-wrap">
        <Packshot product={product} size="card" />
      </div>
      <div>
        <small>{product.division}</small>
        <h3>{product.name}</h3>
        <p>{product.generic}</p>
        <span className="catalog-form-chip">{product.form}</span>
      </div>
      <ArrowUpRight size={17} />
    </motion.article>
  );
}
